import React from 'react';
import classNames from 'classnames';

const styles = require('./LoadingSpinner.module.scss');

type SpinnerSize = 'small' | 'small-medium' | 'medium' | 'medium-large' | 'large';
type SpinnerContext = 'talent' | 'company' | 'neutral';

export interface LoadingSpinnerProps {
  className?: string;
  context?: SpinnerContext;
  label?: string;
  size?: SpinnerSize;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  context = 'neutral',
  label = 'Loading',
  size = 'medium',
}) => {
  return (
    <div
      className={classNames(styles.spinnerContainer, className)}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div
        className={classNames(styles.spinner, styles[size], styles[context])}
        aria-hidden="true"
      />
    </div>
  );
};

export default LoadingSpinner;
